import { IsDateRangeQuery } from '../../dates/helpers/date-range-query-helper';

const FIELD_SEARCH_ESCAPABLE_CHARACTERS: string[] = [
    '+',
    '-',
    '&&',
    '||',
    '!',
    '(',
    ')',
    '{',
    '}',
    '[',
    ']',
    '^',
    `"`,
    '~',
    ':',
    '\\',
    '/'
];

const PHRASEABLE_TOKENS: string[] = [' ', '-', '_', '.'];

const WILDCARD = '*';

function escapeWithBackslash(value: string): string {
    return `\\${value}`;
}

function escapeValues(unescapedValue: string): string {
    const escapeCharacters: string[] = FIELD_SEARCH_ESCAPABLE_CHARACTERS.map(str => `\\${str.split('').join('\\')}`);

    const regExp = new RegExp(escapeCharacters.join('|'), 'gi');

    return unescapedValue.replace(regExp, value => escapeWithBackslash(value));
}

function shouldPhraseValue(escapedValue: string): boolean {
    return PHRASEABLE_TOKENS.some(
        token => escapedValue.includes(token) && !escapedValue.startsWith(escapeWithBackslash(token))
    );
}

/**
 * Escapes a value for a Lucene *field* search. A wildcard value is never phrased, since a phrase reads `*`
 * literally; its spaces are escaped instead. Date ranges are passed through verbatim.
 */
export function SanitizeFieldSearchValue(value: string): string {
    if (IsDateRangeQuery(value)) return value;

    const escaped: string = escapeValues(value);

    if (escaped.includes(WILDCARD)) return escaped.replace(/ /g, escapeWithBackslash(' '));

    return shouldPhraseValue(escaped) ? `"${escaped}"` : escaped;
}
